import React, { useContext, createContext } from "react"
import PropTypes from 'prop-types'

const UpsellContext = createContext({})

const UpsellContextProvider = ({ children, ...props }) => {
  return (
    <UpsellContext.Provider value={props}>
      {children}
    </UpsellContext.Provider>
  )
}

UpsellContextProvider.propTypes = {
  round: PropTypes.number.isRequired,
  businessArea: PropTypes.oneOf(['schueleraustausch', 'sprachreisen']).isRequired,
  initialOrder: PropTypes.object.isRequired,
  onSuccess: PropTypes.func.isRequired,
  upsellCount: PropTypes.number.isRequired,
}

const useUpsellContext = () => {
  const props = useContext(UpsellContext)

  return props
}

export {
  UpsellContext,
  UpsellContextProvider,
  useUpsellContext,
}
